import { useState } from "react"
import toast from "react-hot-toast"

const useValidation = () => {
  const [errors, setErrors] = useState({})
  const validate = (formData, type, api_tag) => {
  
    const newErrors = {}
    if (type === "selection") {
      if (!formData.website) {
        newErrors.website = "Website is required"
        toast.error("Website is required")
      }

      if (!formData.airport) {
        newErrors.airport = "Airport is required"
        toast.error("Airport is required")
      }
    }
    if (type === "booking_form") {
      if (!formData.title) {
        newErrors.title = "Title is required"
        toast.error("Title is required")
      }
      if (!formData.first_name) {
        newErrors.first_name = "First name is required"
        toast.error("First name is required")
      }
      if (!formData.last_name) {
        newErrors.last_name = "Last name is required"
        toast.error("Last name is required")
      }
      if (!formData.email) {
        newErrors.email = "Email is required"
        toast.error("Email is required")
      }
      if (!formData.contact_no) {
        newErrors.contact_no = "Contact number is required"
        toast.error("Contact number is required")
      }
      if (api_tag == "a2z" || api_tag == "fhr") {
        if (!formData.arrival_flight_no) {
          newErrors.arrival_flight_no = "Arrival flight number is required"
          toast.error("Arrival flight number is required")
        }
        if (!formData.arrival_terminal) {
          newErrors.arrival_terminal = "Arrival terminal is required"
          toast.error("Arrival terminal is required")
        }

        if (!formData.departure_flight_no) {
          newErrors.departure_flight_no = "Departure flight number is required"
          toast.error("Departure flight number is required")
        }
        if (!formData.departure_terminal) {
          newErrors.departure_terminal = "Departure terminal is required"
          toast.error("Departure terminal is required")
        }
        if (!formData.make) {
          newErrors.make = "Car make is required"
          toast.error("Car make is required")
        }
        if (!formData.model) {
          newErrors.model = "Car model is required"
          toast.error("Car model is required")
        }
        if (!formData.reg_no) {
          newErrors.reg_no = "Registration number is required"
          toast.error("Registration number is required")
        }
      
        if (!formData.color) {
          newErrors.color = "Car color is required"
          toast.error("Car color is required")
        }
      }
    }
    if (type === "transferBooking") {
      if (!formData.fromAirport) {
        newErrors.fromAirport = "From Airport is required"
        toast.error("From Airport is required")
      }

      if (!formData.fromCompany) {
        newErrors.fromCompany = "From Company is required"
        toast.error("From Company is required")
      }
      if (!formData.toAirport) {
        newErrors.toAirport = "To Airport is required"
        toast.error("To Airport is required")
      }

      if (!formData.toCompany) {
        newErrors.toCompany = "To Company is required"
        toast.error("To Company is required")
      }
    }
    if (type === "Login") {

      if (!formData.email) {
        console.log(errors,"errors")

        newErrors.email = "Email is required"
        toast.error(" Email is required")
      }

      if (!formData.password) {
        newErrors.password = "Password is required"
        toast.error("Password is required")
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }
  return {
    validate,
    errors,
    setErrors,
  }
}

export default useValidation
